export interface IFinalizeDrawResult {
    shouldFinalize: boolean;
}

/**
 * 管理一次绘制代际中的字体准备和结束操作，防止旧异步任务回写新绘制。
 */
export class MarkupDrawLifecycle {
    private generation = 0;
    private finalizingGeneration: number | null = null;
    private finalizedGeneration: number | null = null;
    private fontReadyPromise: Promise<void> = Promise.resolve();

    get currentGeneration() {
        return this.generation;
    }

    reset() {
        this.generation += 1;
        this.finalizingGeneration = null;
        this.finalizedGeneration = null;
        this.fontReadyPromise = Promise.resolve();
        return this.generation;
    }

    isCurrent(generation: number) {
        return generation === this.generation;
    }

    setFontReadyPromise(generation: number, promise: Promise<unknown>) {
        if (!this.isCurrent(generation)) return;
        this.fontReadyPromise = promise.then(() => undefined).catch(() => undefined);
    }

    async beginFinalize(generation: number): Promise<IFinalizeDrawResult> {
        if (
            !this.isCurrent(generation) ||
            this.finalizingGeneration === generation ||
            this.finalizedGeneration === generation
        ) {
            return { shouldFinalize: false };
        }

        this.finalizingGeneration = generation;
        await this.fontReadyPromise;
        if (!this.isCurrent(generation) || this.finalizingGeneration !== generation) {
            return { shouldFinalize: false };
        }

        this.finalizedGeneration = generation;
        return { shouldFinalize: true };
    }
}
